export function filter (state) {
  return state.filter
}

export function initialFilter (state) {
  return state.initialFilter
}
